<dtm-notifications-list
    *ngIf="notificationsList$ | ngrxPush as notificationsList"
    [notificationsList]="notificationsList"
></dtm-notifications-list>
